<template>
  <v-container fluid class="reimbursement-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Items</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Reimbursement</v-stepper-step>
            </v-stepper-header>
          </v-card>
          <v-card>
            <v-stepper-items>
              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Reimbursement</p>
                        <v-select
                          class="mb-4"
                          :items=reimbursementtype
                          v-model="reimbursement.reimbursementtype"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the reimbursement type">
                        </v-select>
                        <v-menu
                          ref="menu_reimbursementdate"
                          v-model="menu_reimbursementdate"
                          :close-on-content-click="false"
                          :return-value.sync="reimbursement.reimbursementdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="reimbursement.reimbursementdate"
                              label="Reimbursement Date"
                              v-bind="attrs"
                              v-bind:value="reimbursement.reimbursementdate"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              single-line hint="Please choose the reimbursement type">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="reimbursement.reimbursementdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_reimbursementdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_reimbursementdate.save(reimbursement.reimbursementdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-switch
                          v-model="reimbursement.reimbursementstatus"
                          color="primary"
                          v-bind:label="reimbursement.reimbursementstatus"
                          value="New"
                        ></v-switch>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="accounts.filter(x=>x.accountsubclass=='Bank').map(x => {
                            return {text: x.accountname, value: x._id};
                            })"
                          v-model="reimbursement.accountid"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Account"
                          persistent-hint
                          single-line hint="Please choose the account">
                        </v-select>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-text-field
                          class="mb-4"
                          v-model="reimbursement.reimbursementnote"
                          outlined
                          dense
                          placeholder="Note"
                          persistent-hint
                          single-line hint="Enter the note">
                        </v-text-field>
                      </v-form>
                    </v-col>                                        
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="9">
                      <div class="d-flex justify-center">
                        <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertReimbursement()">
                            Save
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <p class="text-h5">Reimbursement Items</p>
                      <v-form>
                        <v-row justify="center">
                          <v-col cols="12" md="12">
                          <v-data-table
                            hide-default-footer
                            :headers="orderHeaders"
                            :items="dataClaims"
                            :items-per-page="500"
                            class="elevation-0"
                          >
                            <template v-slot:item.claimnum="{ item }">
                              <p class="two-line">{{ item.claimtype  }}</p>
                              <p class="two-line">{{ item.claimnum  }}</p>
                              <p v-if="item.claimdate!=undefined" class="two-line">{{ new Date(item.claimdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</p>
                            </template>
                            <template v-slot:item.employeeid="{ item }">
                                <v-avatar v-if="employees.length>0 && employees.find(employee=>employee._id == item.employeeid)['employeeimage']!==''" size="40">
                                  <img v-bind:src="employees.find(employee=>employee._id == item.employeeid)['employeeimage']" alt="">
                                </v-avatar>
                                <v-avatar
                                  v-else
                                  color="warning"
                                  size="40">
                                  <span class="white--text headline">{{ employees.length>0 ? employees.find(employee=>employee._id == item.employeeid)['employeename'][0].toUpperCase() : '' }}</span>
                                </v-avatar>
                              </template>
                            <template v-slot:item.claimname="{ item }">
                              <p class="two-line">{{ item.claimname }}</p>
                              <p class="two-line">{{ item.claimaddress }}</p>
                            </template>
                            <template v-slot:item.transactions="{ item }">
                              <p class="two-line">{{ item.transactions.map(trans=>trans.transdesc).join(", ") }}</p>
                            </template>
                            <template v-slot:item.claimtotal="{ item }">
                              {{ item.claimtotal.toLocaleString('en-SG') }}
                            </template>
                            <template v-slot:item.actions="{ item }">
                              <v-btn icon color="primary" @click="deleteOrders(item)">
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </template>
                            <template slot="body.append">
                              <tr>
                                  <th></th>
                                  <th></th>
                                  <th>Total</th>
                                  <th>{{ reimbursement.reimbursementtotal }}</th>
                                  <th></th>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-col>
                        </v-row>
                      </v-form>
                    </v-col>
                  </v-row>
                    <v-row justify="center">
                    <v-col cols="12" md="12">
                        <div class="d-flex justify-center">
                          <v-btn
                              @click="cancelReimbursement"
                              replace
                              outlined
                              color="primary"
                          >
                            Cancel
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                        </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      menu_reimbursementdate: false,
      error: undefined,
      haserror: false,
      errorindex: undefined,
      isFromClaims: false,
      step: 1,
      orderHeaders: [
        { text: 'Claim', value: 'claimnum' },
        { text: 'Image', value: 'employeeid' },
        { text: 'Name', value: 'claimname' },
        { text: 'Description', value: 'transactions' },
        { text: 'Amount', value: 'claimtotal' },
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      dataClaims: [],
      reimbursementtype: ['Reimbursement'],
      reimbursement: {
        reimbursementstatus: 'New',
        reimbursementtotal: 0,
      },
    }
  },
  computed: {
    ...mapState('Reimbursement', ['reimbursements', 'isReceiving']),
    ...mapState('Account', ['accounts']),
    ...mapState('Employee', ['employees']),
    ...mapState('Township', ['townships']),
  },
  methods: {
    ...mapActions('Reimbursement', ['getReimbursements', 'insertReimbursementRequest']),
    ...mapActions('Account', ['getAccountsRequest']),
    ...mapActions('Region', ["getRegionsRequest"]),
    ...mapActions('Employee', ["getEmployeesRequest"]),
    ...mapActions('Township', ["getTownshipsRequest"]),
    calculateTotal(){
      this.reimbursement.reimbursementtotal = this.dataClaims.reduce((partial_sum, item) => parseInt(partial_sum) + parseInt(item.claimtotal),0);
    },
    checkError(){
      if(this.dataClaims.length==0){
        this.haserrors = true;
        return false;
      }
      this.step = 2;
      this.errorindex = -1;
      return true;
    },
    checkError2(){
      this.step = 2;
      if(!this.reimbursement.reimbursementtype){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.reimbursement.reimbursementdate){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.reimbursement.accountid){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    deleteOrders(item){
      let index = this.findOrderIndexById(item._id);
      this.dataClaims.splice(index,1);
      this.calculateTotal();
    },
    findOrderIndexById(id){
      let index;
      if(this.dataClaims.find(item=>item._id==id)==null) {return -1}
      for(index=0; index<this.dataClaims.length; index++){
        if(this.dataClaims[index]._id==id){break;}
      }
      return index;
    },
    cancelReimbursement(){
      if(this.isFromClaims==true){
        let claims = Object.assign([], this.dataClaims);
        let json = {claims: claims, isReimbursement: true};
        router.push({ name: 'ClaimAdmList', params: json });
      }
      else router.push('/reimbursement/list');
    },
    async insertReimbursement() {
      if(!this.checkError2()) return;
      let json = {reimbursement: this.reimbursement, claims: this.dataClaims.map(item=>item._id)}
      await this.insertReimbursementRequest(json);
      router.push('/reimbursement/list');
    },
  },
  async created () {
    this.dataClaims = this.$route.params.claims;
    this.dataClaims.sort((a, b) => a.claimnum - b.claimnum)
    this.isFromClaims = this.$route.params.isClaims;
    this.calculateTotal();
    if(this.accounts.length==0) await this.getAccountsRequest();
    if(this.employees.length==0) await this.getEmployeesRequest();
    if(this.townships.length==0) await this.getTownshipsRequest();
  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
